export const styleFlexDirection = direction => ({
  display: 'flex',
  flexDirection: direction ?? 'column',
})
export const styleFlexColumn = styleFlexDirection('column')
export const styleFlexRow = styleFlexDirection('row')
export const styleWhiteButton = {
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  gap: '5px',
  alignItems: 'center',
  borderRadius: '4px',
  padding: '4px 16px',
  border: '1px solid #adb2b9',
  boxShadow: '1px 1px 1px 1px #adb2b9',
  '-webkit-touch-callout': 'none' /* iOS Safari */,
  '-webkit-user-select': 'none' /* Safari */,
  '-khtml-user-select': 'none' /* Konqueror HTML */,
  '-moz-user-select': 'none' /* Old versions of Firefox */,
  '-ms-user-select': 'none' /* Internet Explorer/Edge */,
  'user-select': 'none' /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */,
}

export const styleWhiteButtonDisabled = () => {
  return {
    ...styleWhiteButton,
    cursor: 'not-allowed',
  }
}
